import React, { Dispatch, SetStateAction, createContext, useState } from 'react';
import { ReactFCC } from '../../interface/react';
import { UserProfile } from '../../interface/user';
import { MemberView } from './interface';

interface SearchProviderContext {
	members: UserProfile[];
	setMembers: Dispatch<SetStateAction<UserProfile[]>>;
	memberView: MemberView;
	setMemberView: Dispatch<SetStateAction<MemberView>>;
}

const defaultValues = {} as SearchProviderContext;

export const SearchContext = createContext<SearchProviderContext>(defaultValues);

interface SearchProviderProps {}

export const SearchProvider: ReactFCC<SearchProviderProps> = ({ children }) => {
	const [members, setMembers] = useState<UserProfile[]>([]);
	const [memberView, setMemberView] = useState<MemberView>(MemberView.GRID);

	const contextValue = React.useMemo(
		() => ({
			members,
			setMembers,
			memberView,
			setMemberView,
		}),
		[members, setMembers, memberView, setMemberView]
	);

	return <SearchContext.Provider value={contextValue}>{children}</SearchContext.Provider>;
};

export default SearchProvider;
